module.exports = __webpack_public_path__ + "media/application/images/wjc-white-953ec95ca701396b4c429fee32e83657bf1566cd56f9e442c68b7fc7293c9790.png";